//This file is used for maintain JavaScript functions that are bound to a particular scope or view
;(function (module) {
  'use strict'
  module.controller('travelerTrackController', [
    '$rootScope',
    '$scope',
    '$http',
    '$state',
    '$document',
    'progressBar',
    'ngDialog',
    'toastr',
    'currency',
    'travelerTrack',
    'tripsDashBoard',
    '$filter',
    '$window',
    'commonDialogMessage',
    '$compile',
    'organizations',
    'socketLogin',
    'uiGridConstants',
    'clientSelectService',
    'agencySelectService',
    'toastFactory',
    'authService',
    '$q',
    'smsStatus',
    'obexRoles',
    function (
      $rootScope,
      $scope,
      $http,
      $state,
      $document,
      progressBar,
      ngDialog,
      toastr,
      currency,
      travelerTrack,
      tripsDashBoard,
      $filter,
      $window,
      commonDialogMessage,
      $compile,
      organizations,
      socketLogin,
      uiGridConstants,
      clientSelectService,
      agencySelectService,
      toastFactory,
      authService,
      $q,
      smsStatus,
      obexRoles,
    ) {
      //variable declaration
      let progress = progressBar.getProgressBar()
      let storage = $window.localStorage
      $scope.statusNote = {
        Id: 0,
        NewAgentNote: '',
        BookingType: '',
      }
      $scope.pre31days = false
      $scope.next24hours = true
      $scope.days1to7 = false
      $scope.post31days = false
      $scope.customDate = false
      $scope.customFromDate = new Date()
      $scope.cities = []
      $scope.customToDate = addMonth($scope.customFromDate) // Look ahead 1 month by default
      $scope.isTravelers = true
      $scope.isAlerts = true
      $scope.isTravelersNearToAlerts = false
      $scope.isCustomDate = false
      $scope.isTravelerMarkerContent = false
      $scope.isDetails = false
      let maps = null
      $scope.isExportData = false
      let infoWindow = null
      $scope.isTripsDash = false
      $scope.selectedCityName = ''
      let selectedClientId = clientSelectService.getSelectedClient().id
      let markerContent = ''
      let markerLocators = null
      let parentListTravelersListByTripId = []

      function addMonth(startDate) {
        // Does not handle end-of-month edge case, e.g. Oct 31 + 1 month = Dec 01
        return new Date(new Date(startDate).setMonth(startDate.getMonth() + 1))
      }

      $scope.sendSms = function (
        bookingId,
        devicetoken,
        osplatform,
        bookingType,
      ) {
        console.log(bookingId)
        console.log(bookingType)
        console.log(devicetoken)
        console.log(osplatform)
        $scope.bookingId = bookingId
        $scope.devicetoken = devicetoken
        $scope.osplatform = osplatform
        $scope.bookingType = bookingType
        ngDialog.open({
          template: 'templates/partials/agentInitiatedMessage.html',
          className: 'ngdialog-theme-plain',
          scope: $scope,
          closeByEscape: false,
          closeByDocument: false,
        })
      }
      $scope.confirmSendSms = function () {
        var loginUser = authService.getLoginMember()
        loginUser['SupportedOrganizations'] = []
        console.log('$scope.smsText ', $scope.smsText)
        console.log('$scope.selectedRow ', $scope.selectedRow)
        const traveler = $scope.selectedRow.Member
          ? $scope.selectedRow.Member
          : $scope.selectedRow.Traveler
        $scope.TravelerEmail = !$scope.TravelerEmail
          ? traveler.Email
          : $scope.TravelerEmail
        $scope.TravelerCompanyId = !$scope.TravelerCompanyId
          ? traveler.OrganizationId
          : $scope.TravelerCompanyId
        $http.post('/agentsms', {
          alerttext: $scope.smsText,
          payload: {
            aps: {
              'content-available': 1,
              bookingId: $scope.bookingId,
              bookingType: $scope.bookingType,
              alertText: $scope.smsText,
            },
          },
          devicetoken: $scope.devicetoken,
          osplatform: $scope.osplatform,
          agentEmail: loginUser.Email,
          agencyId: loginUser.Organization.Id,
          travelerEmail: $scope.TravelerEmail,
          clientId: $scope.TravelerCompanyId,
        })

        console.log('socketId: ', socketLogin.getSocketId())

        var handleData = {
          fromNumber: traveler.Phone,
          socketId: socketLogin.getSocketId(),
          firstName: loginUser.FirstName,
          lastName: loginUser.LastName,
          email: loginUser.Email,
          organizationId: loginUser.Organization.Id,
          loginMember: loginUser,
          smstext: $scope.smsText,
          travelAgencyId: loginUser.Organization.Id,
          travelAgencyName: loginUser.Organization.Name,
          travelAgentFirstName: loginUser.FirstName,
          travelAgentLastName: loginUser.LastName,
          travelAgentEmail: loginUser.Email,
          travelAgentId: loginUser.Id,
          topic: {
            bookingId: $scope.bookingId,
            bookingType: $scope.bookingType,
            email: $scope.TravelerEmail,
            phoneNumber: traveler.Phone,
          },
          travelerFirstName: traveler.FirstName,
          travelerLastName: traveler.LastName,
          travelerOrganizationName: traveler.Organization.Name,
          travelerId: traveler.Id,
        }

        const data = {
          travelerNumber: traveler.Phone,
          travelerFirstName: traveler.FirstName,
          travelerLastName: traveler.LastName,
          travelerEmail: traveler.Email,
          socketId: socketLogin.getSocketId(),
          travelAgentFirstName: loginUser.FirstName,
          travelAgentLastName: loginUser.LastName,
          travelAgentEmail: loginUser.Email,
          travelAgentId: loginUser.Id,
          travelAgentOrganizationId: loginUser.Organization.Id,
          loginMemberId: loginUser.Id,
          smstext: $scope.smsText,
          topic: {
            bookingId: $scope.bookingId,
            bookingType: $scope.bookingType,
            email: traveler.Email,
            phoneNumber: traveler.Phone,
          },
          travelerId: traveler.Id,
          fromDatabase: false,
          channel: 'sms',
        }
        $http
          .post('/agentInitiatedSms', data)
          .then((response) => {
            $rootScope.$broadcast('smsHandle', handleData)
            return $http.post('/handleConversation', handleData)
          })
          .then(
            (response) => {
              $state.go('app.sms', {
                fromNumber: traveler.Phone,
                travelerFirstName: traveler.FirstName,
                travelerLastName: traveler.LastName,
                travelerOrganizationName: traveler.Organization.Name,
                travelerId: traveler.Id,
                status: smsStatus.Live,
                fromDatabase: false,
                channel: 'sms',
                organizationId: traveler.Organization.Id,
                topic: {
                  bookingId: $scope.bookingId,
                  bookingType: $scope.bookingType,
                  email: $scope.TravelerEmail,
                  phoneNumber: traveler.Phone,
                },
              })
            },
            (error) => {
              console.log(error)
            },
          )
      }

      //Setting up map and markers
      const mapOptions = {
        zoom: 3,
        center: new google.maps.LatLng(20, -65),
        mapTypeId: google.maps.MapTypeId.TERRAIN,
      }

      //Alerts Grid
      $scope.alertsGrid = {
        paginationPageSizes: [5, 10, 25, 50],
        enableFiltering: true,
        enableGridMenu: false,
        paginationPageSize: 10,
        useExternalPagination: true,
        useExternalSorting: false,
        enableRowSelection: true,
        enableSelectAll: false,
        enableRowHeaderSelection: false,
        multiSelect: false,
        rowHeight: 20,
        columnDefs: [
          {
            name: 'title',
            displayName: 'Alerts',
            cellTemplate:
              '<span style="padding:3px">{{ row.entity.title }}</span>',
            enableHiding: false,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableSorting: true,
            enableFiltering: true,
            enableRowSelection: true,
          },
        ],
        //Information Pop up on selection of Alerts grid row
        onRegisterApi: function (gridApiAlerts) {
          $scope.gridApiAlerts = gridApiAlerts
          gridApiAlerts.selection.on.rowSelectionChanged($scope, function (
            row,
          ) {
            if ($scope.isAlerts) {
              google.maps.event.trigger(row.entity, 'click')
            }
          })
        },
      }

      maps = new google.maps.Map(document.getElementById('map'), mapOptions)
      infoWindow = new google.maps.InfoWindow()
      //Load alerts from web service
      function loadAlerts(maps, infoWindow) {
        progress.start()
        $scope.AlertMarkers = []
        $scope.alertsGrid.data = []
        travelerTrack
          .getAlerts()
          .then(
            function (alerts) {
              let alertsListcontext = alerts.data

              $scope.AlertMarkers = alertsListcontext.map(function (alertlist) {
                let alertValue = 8
                if (alertlist.Title.indexOf('Level 1') !== -1) {
                  alertValue = 1
                } else if (alertlist.Title.indexOf('Level 2') !== -1) {
                  alertValue = 2
                } else if (alertlist.Title.indexOf('Level 3') !== -1) {
                  alertValue = 4
                }
                let alertMarker = createAlertMarker(
                  alertlist,
                  alertValue,
                  maps,
                  infoWindow,
                )
                if (alertValue === 8) {
                  alertMarker.setVisible(true)
                } else {
                  alertMarker.setVisible(false)
                }
                return alertMarker
              })

              $scope.alertsGrid.data = $scope.AlertMarkers.filter(
                (alertMarker) => alertMarker.visible === true,
              )
            },
            function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: [
                    '$scope',
                    function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`
                      $scope.errTitle = 'Traveler Track Load Alert Error'
                    },
                  ],
                })
              }
            },
          )
          .finally(function () {
            progress.complete()
          })
      }

      function generateNotesHistory() {
        progress.start()
        let id = storage.getItem('id')
        $scope.statusNote.BookingType = storage.getItem('bookingType')
        if ($scope.statusNote.BookingType === 'Flight' && $scope.isVisible) {
          tripsDashBoard
            .getFlightsDashById(id)
            .then(
              function (tripsFlights) {
                let tripsFlightsContext = tripsFlights.data.AgentNotes
                if (tripsFlights.data.HasAgentNotes) {
                  $scope.notesHistoryList = tripsFlightsContext.map(function (
                    agentNote,
                  ) {
                    return {
                      Agent:
                        agentNote.Agent.FirstName +
                        ' ' +
                        agentNote.Agent.LastName,
                      Note: agentNote.Note,
                      NoteTime:
                        $filter('date')(agentNote.LastUpdated, 'MM-dd-yyyy') +
                        '   ' +
                        $filter('date')(agentNote.LastUpdated, 'shortTime'),
                    }
                  })
                }
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: [
                      '$scope',
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`
                        $scope.errTitle = 'Notes Error'
                      },
                    ],
                  })
                }
              },
            )
            .finally(function () {
              progress.complete()
            })
        }
        // generate Car booking details
        else if ($scope.statusNote.BookingType === 'Car' && $scope.isVisible) {
          tripsDashBoard
            .getCarsDashById(id)
            .then(
              function (tripsCars) {
                let tripsCarsContext = tripsCars.data.AgentNotes
                if (tripsCars.data.HasAgentNotes) {
                  $scope.notesHistoryList = tripsCarsContext.map(function (
                    agentNote,
                  ) {
                    return {
                      Agent:
                        agentNote.Agent.FirstName +
                        ' ' +
                        agentNote.Agent.LastName,
                      Note: agentNote.Note,
                      NoteTime:
                        $filter('date')(agentNote.LastUpdated, 'MM-dd-yyyy') +
                        '   ' +
                        $filter('date')(agentNote.LastUpdated, 'shortTime'),
                    }
                  })
                }
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: [
                      '$scope',
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`
                        $scope.errTitle = 'Notes Error'
                      },
                    ],
                  })
                }
              },
            )
            .finally(function () {
              progress.complete()
            })
        }
        // generate hotel booking details
        else if (
          $scope.statusNote.BookingType === 'Hotel' &&
          $scope.isVisible
        ) {
          tripsDashBoard
            .getHotelsDashById(id)
            .then(
              function (tripsHotels) {
                let tripsHotelsContext = tripsHotels.data.AgentNotes
                if (tripsHotels.data.HasAgentNotes) {
                  $scope.notesHistoryList = tripsHotelsContext.map(function (
                    agentNote,
                  ) {
                    return {
                      Agent:
                        agentNote.Agent.FirstName +
                        ' ' +
                        agentNote.Agent.LastName,
                      Note: agentNote.Note,
                      NoteTime:
                        $filter('date')(agentNote.LastUpdated, 'MM-dd-yyyy') +
                        '   ' +
                        $filter('date')(agentNote.LastUpdated, 'shortTime'),
                    }
                  })
                }
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: [
                      '$scope',
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`
                        $scope.errTitle = 'Notes Error'
                      },
                    ],
                  })
                }
              },
            )
            .finally(function () {
              progress.complete()
            })
        } else if (
          $scope.statusNote.BookingType === 'Limo' &&
          $scope.isVisible
        ) {
          tripsDashBoard
            .getLimosDashById(id)
            .then(
              function (tripsLimos) {
                let tripsLimosContext = tripsLimos.data.AgentNotes
                if (tripsLimos.data.HasAgentNotes) {
                  $scope.notesHistoryList = tripsLimosContext.map(function (
                    agentNote,
                  ) {
                    return {
                      Agent:
                        agentNote.Agent.FirstName +
                        ' ' +
                        agentNote.Agent.LastName,
                      Note: agentNote.Note,
                      NoteTime:
                        $filter('date')(agentNote.LastUpdated, 'MM-dd-yyyy') +
                        '   ' +
                        $filter('date')(agentNote.LastUpdated, 'shortTime'),
                    }
                  })
                }
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: [
                      '$scope',
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`
                        $scope.errTitle = 'Notes Error'
                      },
                    ],
                  })
                }
              },
            )
            .finally(function () {
              progress.complete()
            })
        }
      }
      $scope.notesHistory = function () {
        $scope.isVisible = $scope.isVisible ? false : true
        generateNotesHistory()
      }
      $scope.saveBookingStatus = function () {
        progress.start()
        const id = storage.getItem('id')
        $scope.statusNote.BookingType = storage.getItem('bookingType')
        $scope.statusNote.Id = id
        const toDate = $filter('date')(
          new Date(storage.getItem('dateTo')),
          'yyyy-MM-dd',
        )
        const fromDate = $filter('date')(
          new Date(storage.getItem('dateFrom')),
          'yyyy-MM-dd',
        )
        $scope.dateTo = toDate
        $scope.dateFrom = fromDate
        //Update flight booking status
        if ($scope.statusNote.BookingType === 'Flight') {
          tripsDashBoard
            .updateFlightStatus(id, $scope.statusNote)
            .then(
              function (flightUpdate) {
                const dialogPost = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: [
                    '$scope',
                    function ($scope) {
                      $scope.successMsg =
                        commonDialogMessage.tripDashStatusUpdatedMessage
                      $scope.strTitle = 'Notes Created Success'
                    },
                  ],
                })
                dialogPost.closePromise.then(function (data) {
                  $scope.statusNote = {}
                  $scope.editStatusForm.$setPristine()
                  if ($scope.isVisible) {
                    generateNotesHistory()
                  }
                })
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: [
                      '$scope',
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`
                        $scope.errTitle = 'Notes Error'
                      },
                    ],
                  })
                }
              },
            )
            .finally(function () {
              progress.complete()
            })
        }
        //Update Car booking status
        else if ($scope.statusNote.BookingType === 'Car') {
          tripsDashBoard
            .updateCarStatus(id, $scope.statusNote)
            .then(
              function (carUpdate) {
                const dialogPost = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: [
                    '$scope',
                    function ($scope) {
                      $scope.successMsg =
                        commonDialogMessage.tripDashStatusUpdatedMessage
                      $scope.strTitle = 'Notes Created Success'
                    },
                  ],
                })
                dialog.closePromise.then(function (data) {
                  $scope.statusNote = {}
                  $scope.editStatusForm.$setPristine()
                  if ($scope.isVisible) {
                    generateNotesHistory()
                  }
                })
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: [
                      '$scope',
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`
                        $scope.errTitle = 'Notes Error'
                      },
                    ],
                  })
                }
              },
            )
            .finally(function () {
              progress.complete()
            })
        }
        //Update Hotel booking status
        else if ($scope.statusNote.BookingType === 'Hotel') {
          tripsDashBoard
            .updateHotelStatus(id, $scope.statusNote)
            .then(
              function (hotelUpdate) {
                const dialogPost = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: [
                    '$scope',
                    function ($scope) {
                      $scope.successMsg =
                        commonDialogMessage.tripDashStatusUpdatedMessage
                      $scope.strTitle = 'Notes Created Success'
                    },
                  ],
                })
                dialogPost.closePromise.then(function (data) {
                  $scope.statusNote = {}
                  $scope.editStatusForm.$setPristine()
                  if ($scope.isVisible) {
                    generateNotesHistory()
                  }
                })
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: [
                      '$scope',
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`
                        $scope.errTitle = 'Notes Error'
                      },
                    ],
                  })
                }
              },
            )
            .finally(function () {
              progress.complete()
            })
        }
        //Update Limo booking status
        else if ($scope.statusNote.BookingType === 'Limo') {
          tripsDashBoard
            .updateLimoStatus(id, $scope.statusNote)
            .then(
              function (limoUpdate) {
                const dialogPost = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: [
                    '$scope',
                    function ($scope) {
                      $scope.successMsg =
                        commonDialogMessage.tripDashStatusUpdatedMessage
                      $scope.strTitle = 'Notes Created Success'
                    },
                  ],
                })
                dialogPost.closePromise.then(function (data) {
                  $scope.statusNote = {}
                  $scope.editStatusForm.$setPristine()
                  if ($scope.isVisible) {
                    generateNotesHistory()
                  }
                })
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: [
                      '$scope',
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`
                        $scope.errTitle = 'Notes Error'
                      },
                    ],
                  })
                }
              },
            )
            .finally(function () {
              progress.complete()
            })
        }
      }
      //edit status and notes by Id
      generateNotesHistory()
      $scope.editStatus = function (id, bookingType) {
        $scope.statusNote = {}
        $scope.statusNote.BookingType = bookingType
        storage.setItem('bookingType', bookingType)
        storage.setItem('id', id)
        ngDialog.open({
          template: 'templates/partials/editStatusTripDash.html',
          controller: 'tripsDashBoardController',
          closeByDocument: false,
        })
      }

      function getCities(selectedClientId) {
        progress.start()
        const promiseDepartureCities = travelerTrack.getDepartureCities(
          selectedClientId,
        )
        const promiseArrivalCities = travelerTrack.getArrivalCities(
          selectedClientId,
        )
        $q.all([promiseDepartureCities, promiseArrivalCities])
          .then(
            function (response) {
              $scope.cities = angular.merge(response[0].data, response[1].data)
            },
            function (err) {
              console.log(err)
            },
          )
          .finally(function () {
            progress.complete()
          })
      }
      loadAlerts(maps, infoWindow)
      //Load travelers data from web service
      function searchTravelersData(fromDate, toDate, maps, infoWindow) {
        let travelersNearAlert = $scope.isTravelersNearToAlerts
        if (authService.getLoginMember().Role === 3) {
          selectedClientId = authService.getLoginMember().OrganizationId
          getCities(selectedClientId)
          getTravelerData(
            fromDate,
            toDate,
            travelersNearAlert,
            selectedClientId,
          )
        } else {
          const valid = validateAgencyAndClientSelection()
          if (valid.agencyValid && valid.clientValid) {
            selectedClientId = clientSelectService.getSelectedClient().id
            getCities(selectedClientId)
            getTravelerData(
              fromDate,
              toDate,
              travelersNearAlert,
              selectedClientId,
            )
          } else if (valid.agencyValid) {
            //toastFactory.toast_info('Please select a client.');
          } else {
            //toastFactory.toast_info('Please select an agency and then client.');
          }
        }
      }
      $scope.searchTravelersByCity = function (selectedCityName) {
        $scope.selectedCityName = selectedCityName
        $scope.searchTravelersNearAlertsOrInCity()
      }

      function createMarkerLocators(markerData) {
        let markerLocators = {}
        for (let i = 0; i < markerData.length; i++) {
          let travelerLocation = markerData[i]
          if (travelerLocation.Location != null) {
            let cityName = travelerLocation.Location
            if (markerLocators[cityName]) {
              markerLocators[cityName].push(travelerLocation)
            } else {
              markerLocators[cityName] = []
              markerLocators[cityName].push(travelerLocation)
            }
          }
        }
        return markerLocators
      }
      $document.on('click', '.prevLocator, .nextLocator', function (event) {
        if (!angular.element(event.target).hasClass('disabled')) {
          let cityName = event.target.parentElement.getAttribute(
            'data-cityname',
          )
          if (
            markerLocators[cityName] &&
            Array.isArray(markerLocators[cityName]) &&
            markerLocators[cityName].length > 0
          ) {
            const userRole = authService.getLoginMember().Role
            let markerIndexNum = parseInt(
              event.target.parentElement.getAttribute('data-idx'),
              10,
            )
            markerIndexNum = angular
              .element(event.target)
              .hasClass('prevLocator')
              ? --markerIndexNum
              : ++markerIndexNum
            let markerData = markerLocators[cityName][markerIndexNum]
            let bookingType, bookingId, contentWindow, DeviceToken, OSPlatform
            let markerContent = createrMarkerContent(markerData)
            let arrTravelersData = getTravelersDataByDateAsc(markerData)
            bookingType = arrTravelersData['bookingType']
            bookingId = arrTravelersData['bookingId']
            DeviceToken = arrTravelersData['DeviceToken']
            OSPlatform = arrTravelersData['OSPlatform']
            arrTravelersData.forEach(function (objTraveler) {
              if (objTraveler.hasOwnProperty('DepartureDateTime')) {
                markerContent = createFlightMarker([objTraveler], markerContent)
              } else if (objTraveler.hasOwnProperty('PickUpDateTime')) {
                markerContent = createCarMarker([objTraveler], markerContent)
              } else if (objTraveler.hasOwnProperty('DepartureDate')) {
                markerContent = createLimoMarker([objTraveler], markerContent)
              } else {
                markerContent = createHotelMarker([objTraveler], markerContent)
              }
              parentListTravelersListByTripId[markerData.TripId]
                ? (markerData.DisplayTitle = markerData.travelerName)
                : (markerData.DisplayTitle = markerData.DisplayTitle)
              markerData.content = markerContent
              markerData.city = markerData.Location
              let demoContentWindow = showInfoMarkerWindow(
                userRole,
                markerData,
                bookingType,
                bookingId,
                markerIndexNum,
                DeviceToken,
                OSPlatform,
              )
              let democompiled = $compile(demoContentWindow)($scope)
              infoWindow.setContent(democompiled[0])
            })
          }
        }
      })

      function getTravelerData(
        fromDate,
        toDate,
        travelersNearAlert,
        selectedClientId,
      ) {
        //marker for traveler
        $scope.travelersMarkers = []
        //for making travelersList blank
        $scope.travelersList = []
        progress.start()
        travelerTrack
          .getTravelers(
            fromDate,
            toDate,
            travelersNearAlert.toString(),
            selectedClientId,
          )
          .then(
            function (travelers) {
              let travelersListContext = travelers.data
              let tempMarkerLocators = []
              $scope.isDetails = false

              if (!!travelersListContext.length) {
                for (let traveler of travelersListContext) {
                  let isCityNameExit = false
                  if (!!$scope.selectedCityName.length) {
                    if (!traveler.Trip) {
                      if (!!traveler.Flight) {
                        isCityNameExit = traveler.Flight.some(
                          (flight) =>
                            flight.DepartureName == $scope.selectedCityName ||
                            flight.ArrivalName == $scope.selectedCityName,
                        )
                      } else if (!!traveler.Car) {
                        isCityNameExit = traveler.Car.some(
                          (car) =>
                            car.DropOffLocation == $scope.selectedCityName ||
                            car.PickUpLocation == $scope.selectedCityName,
                        )
                      } else if (!!traveler.Hotel) {
                        isCityNameExit = traveler.Hotel.some(
                          (hotel) => hotel.CityName == $scope.selectedCityName,
                        )
                      } else if (!!traveler.Limo) {
                        isCityNameExit = traveler.Limo.some(
                          (limo) =>
                            limo.LocationName == $scope.selectedCityName ||
                            limo.DropOff == $scope.selectedCityName ||
                            limo.PickUp == $scope.selectedCityName,
                        )
                      }
                    } else {
                      if (!!traveler.Trip.Flights.length) {
                        isCityNameExit = traveler.Trip.Flights.some(
                          (flight) =>
                            flight.DepartureName == $scope.selectedCityName ||
                            flight.ArrivalName == $scope.selectedCityName,
                        )
                      } else if (!!traveler.Trip.Cars.length) {
                        isCityNameExit = traveler.Trip.Cars.some(
                          (car) =>
                            car.DropOffLocation == $scope.selectedCityName ||
                            car.PickUpLocation == $scope.selectedCityName,
                        )
                      } else if (!!traveler.Trip.Hotels.length) {
                        isCityNameExit = traveler.Trip.Hotels.some(
                          (hotel) => hotel.CityName == $scope.selectedCityName,
                        )
                      } else if (!!traveler.Trip.Limos.length) {
                        isCityNameExit = traveler.Trip.Limos.some(
                          (limo) =>
                            limo.LocationName == $scope.selectedCityName ||
                            limo.DropOff == $scope.selectedCityName ||
                            limo.PickUp == $scope.selectedCityName,
                        )
                      }
                    }
                  }

                  if (
                    ((isCityNameExit === false &&
                      $scope.selectedCityName.length == 0) ||
                      (isCityNameExit === true &&
                        !!$scope.selectedCityName.length)) &&
                    traveler.DisplayTitle
                  ) {
                    let name
                    if (
                      traveler.Trip &&
                      traveler.Trip.Flights.length !== 0 &&
                      !!traveler.Trip.Flights[0].AirReservation &&
                      !!traveler.Trip.Flights[0].AirReservation.AirTravelers &&
                      traveler.Trip.Flights[0].AirReservation.AirTravelers
                        .length > 0 &&
                      traveler.Trip.Flights[0].AirReservation.AirTravelers[0]
                        .LastName !== null &&
                      traveler.Trip.Flights[0].AirReservation.AirTravelers[0]
                        .GivenName !== null
                    ) {
                      traveler.travelerName =
                        traveler.Trip.Flights[0].AirReservation.AirTravelers[0]
                          .LastName +
                        ', ' +
                        traveler.Trip.Flights[0].AirReservation.AirTravelers[0]
                          .GivenName
                    } else if (
                      traveler.Trip &&
                      traveler.Trip.Hotels.length !== 0 &&
                      traveler.Trip.Hotels[0].GuestNames !== null
                    ) {
                      name = traveler.Trip.Hotels[0].GuestNames
                      name = name.split(' ')
                      traveler.travelerName = name[1] + ', ' + name[0]
                    } else if (
                      traveler.Trip &&
                      traveler.Trip.Cars.length !== 0 &&
                      traveler.Trip.Cars[0].Travelers !== null
                    ) {
                      name = traveler.Trip.Cars[0].Travelers
                      name = name.split(' ')
                      traveler.travelerName = name[1] + ', ' + name[0]
                    } else if (
                      traveler.Trip &&
                      traveler.Trip.Limos &&
                      traveler.Trip.Limos.length !== 0 &&
                      traveler.Trip.Limos[0].Travelers !== null
                    ) {
                      name = traveler.Trip.Limos[0].Travelers
                      name = name.split(' ')
                      traveler.travelerName = name[1] + ', ' + name[0]
                    } else {
                      traveler.travelerName =
                        traveler.LastName + ', ' + traveler.FirstName
                    }
                    let travelerMarker = createTravelerMarker(
                      traveler,
                      maps,
                      infoWindow,
                    )
                    travelerMarker.setVisible($scope.isTravelers)
                    $scope.travelersMarkers.push(travelerMarker)
                    tempMarkerLocators.push(traveler)
                  }
                }

                markerLocators = createMarkerLocators(tempMarkerLocators)
              }
              $scope.isExportData = !!$scope.travelersMarkers.length
                ? true
                : false
              setTravelersGridData($scope.travelersMarkers)
            },
            function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: [
                    '$scope',
                    function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`
                      $scope.errTitle = 'Traveler Track search Error' //PLACE HOLDER
                    },
                  ],
                })
              }
            },
          )
          .finally(function () {
            progress.complete()
          })
        exportToExcel(fromDate, toDate, selectedClientId)
      }

      function createrMarkerContent(traveler) {
        markerContent =
          '&nbsp;<b>(' + traveler.City + ',&nbsp' + traveler.Country + ')</b>'
        if (traveler.Trip != null) {
          markerContent =
            markerContent +
            '<p style="margin-top:10px;"><b>Trip</b>&nbsp;&nbsp;(' +
            $filter('date')(traveler.Trip.StartDate, 'mediumDate') +
            ' &#8212; ' +
            $filter('date')(traveler.Trip.EndDate, 'mediumDate') +
            ')</p>'
        }
        return markerContent
      }

      function getTravelersDataByDateAsc(traveler) {
        let flightList = [],
          carList = [],
          hotelList = [],
          limoList = []
        let bookingType, bookingId, DeviceToken, OSPlatform

        if (!!traveler.Trip && !!traveler.Trip.Member) {
          $scope.selectedRow = traveler.Trip
          DeviceToken = traveler.Trip.Member.DeviceToken
          OSPlatform = traveler.Trip.Member.OSPlatform
        }
        // creating flight marker
        if (
          (!!traveler.Trip && !!traveler.Trip.Flights.length) ||
          !!traveler.Flight
        ) {
          if (!traveler.Trip) {
            $scope.selectedRow = traveler.Flight
            flightList.push(traveler.Flight)
            bookingType = 'Flight'
            bookingId = traveler.FlightId
          } else {
            flightList = traveler.Trip.Flights
            bookingType = 'Trip'
            bookingId = traveler.TripId
          }
        }
        // creating Car marker
        if (
          (!!traveler.Trip && !!traveler.Trip.Cars.length) ||
          !!traveler.Car
        ) {
          if (!traveler.Trip) {
            $scope.selectedRow = traveler.Car
            carList.push(traveler.Car)
            bookingType = 'Car'
            bookingId = traveler.CarId
          } else {
            carList = traveler.Trip.Cars
            bookingType = 'Trip'
            bookingId = traveler.TripId
          }
        }
        // creating Hotel marker
        if (
          (!!traveler.Trip && !!traveler.Trip.Hotels.length) ||
          !!traveler.Hotel
        ) {
          if (!traveler.Trip) {
            $scope.selectedRow = traveler.Hotel
            hotelList.push(traveler.Hotel)
            bookingType = 'Hotel'
            bookingId = traveler.HotelId
          } else {
            hotelList = traveler.Trip.Hotels
            bookingType = 'Trip'
            bookingId = traveler.TripId
          }
        }
        // creating Limo marker
        if (
          (!!traveler.Trip &&
            traveler.Trip.Limos &&
            !!traveler.Trip.Limos.length) ||
          !!traveler.Limo
        ) {
          if (!traveler.Trip) {
            $scope.selectedRow = traveler.Limo
            limoList.push(traveler.Limo)
            bookingType = 'Limo'
            bookingId = traveler.LimoId
          } else {
            limoList = traveler.Trip.Limos
            bookingType = 'Trip'
            bookingId = traveler.TripId
          }
        }
        let sortTravelersDataByDateAsc = function (currData, nextData) {
          let firstStartDate, secondStartDate
          if (currData.hasOwnProperty('DepartureDateTime')) {
            firstStartDate = moment(currData.DepartureDateTime).format(
              'MM-DD-YYYY',
            )
          } else if (currData.hasOwnProperty('PickUpDateTime')) {
            firstStartDate = moment(currData.PickUpDateTime).format(
              'MM-DD-YYYY',
            )
          } else if (currData.hasOwnProperty('DepartureDate')) {
            firstStartDate = moment(currData.DepartureDate).format('MM-DD-YYYY')
          } else {
            firstStartDate = moment(currData.CheckInDate).format('MM-DD-YYYY')
          }
          if (nextData.hasOwnProperty('DepartureDateTime')) {
            secondStartDate = moment(nextData.DepartureDateTime).format(
              'MM-DD-YYYY',
            )
          } else if (nextData.hasOwnProperty('PickUpDateTime')) {
            secondStartDate = moment(nextData.PickUpDateTime).format(
              'MM-DD-YYYY',
            )
          } else if (currData.hasOwnProperty('DepartureDate')) {
            secondStartDate = moment(currData.DepartureDate).format(
              'MM-DD-YYYY',
            )
          } else {
            secondStartDate = moment(nextData.CheckInDate).format('MM-DD-YYYY')
          }
          if (firstStartDate > secondStartDate) {
            return 1
          } else if (firstStartDate < secondStartDate) {
            return -1
          } else if (firstStartDate === secondStartDate) {
            if (
              currData.BookingTypeName === 'A' &&
              nextData.BookingTypeName === 'A'
            ) {
              const tempStartDate = moment(a.DepartureDateTime).format(
                'MM-DD-YYYY HH:mm',
              )
              const tempEndDate = moment(b.DepartureDateTime).format(
                'MM-DD-YYYY HH:mm',
              )
              if (tempStartDate > tempEndDate) {
                return 1
              } else {
                return -1
              }
            } else if (currData.hasOwnProperty('DepartureDateTime')) {
              return -1
            } else if (nextData.hasOwnProperty('DepartureDateTime')) {
              return 1
            } else if (
              currData.hasOwnProperty('CheckInDate') &&
              nextData.hasOwnProperty('PickUpDateTime')
            ) {
              return -1
            } else if (
              currData.hasOwnProperty('PickUpDateTime') &&
              nextData.hasOwnProperty('CheckInDate')
            ) {
              return 1
            } else {
              return 0
            }
          }
        }
        let arrTravelersData = [
          flightList,
          carList,
          hotelList,
          limoList,
        ].reduce(function (prevData, currData) {
          return prevData.concat(currData)
        }, [])
        arrTravelersData.sort(sortTravelersDataByDateAsc)
        arrTravelersData['bookingType'] = bookingType
        arrTravelersData['bookingId'] = bookingId
        arrTravelersData['DeviceToken'] = DeviceToken
        arrTravelersData['OSPlatform'] = OSPlatform
        return arrTravelersData
      }

      function createTravelerMarker(traveler, maps, infoWindow) {
        let marker = new google.maps.Marker({
          map: maps,
          position: new google.maps.LatLng(
            traveler.Latitude,
            traveler.Longitude,
          ),
          title: traveler.Location,
          icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
          displayTitle: traveler.DisplayTitle,
          city: traveler.Location,
          TripId: traveler.TripId,
          travelerName: traveler.travelerName,
        })
        //Displaying marker on click
        google.maps.event.addListener(marker, 'click', function () {
          const userRole = authService.getLoginMember().Role
          let markerContent = createrMarkerContent(traveler)
          let arrTravelersData = getTravelersDataByDateAsc(traveler)
          let bookingType, bookingId, contentWindow, DeviceToken, OSPlatform
          bookingType = arrTravelersData['bookingType']
          bookingId = arrTravelersData['bookingId']
          DeviceToken = arrTravelersData['DeviceToken']
          OSPlatform = arrTravelersData['OSPlatform']
          let markerIndex = markerLocators[traveler.City]
            .map(function (item) {
              return item.TripId
            })
            .indexOf(traveler.TripId)
          arrTravelersData.forEach(function (objTraveler) {
            if (objTraveler.hasOwnProperty('DepartureDateTime')) {
              markerContent = createFlightMarker([objTraveler], markerContent)
            } else if (objTraveler.hasOwnProperty('PickUpDateTime')) {
              markerContent = createCarMarker([objTraveler], markerContent)
            } else if (objTraveler.hasOwnProperty('DepartureDate')) {
              markerContent = createLimoMarker([objTraveler], markerContent)
            } else {
              markerContent = createHotelMarker([objTraveler], markerContent)
            }
            marker.content = markerContent
            contentWindow = showInfoMarkerWindow(
              userRole,
              marker,
              bookingType,
              bookingId,
              markerIndex,
              DeviceToken,
              OSPlatform,
            )
            let compiled = $compile(contentWindow)($scope)
            infoWindow.setContent(compiled[0])
            infoWindow.open(maps, marker)
          })
        })
        return marker
      }
      google.maps.event.addListener(maps, 'click', function (event) {
        infoWindow.close()
      })

      function createCarMarker(carList, markerContent) {
        markerContent = carList.reduce(function (content, car) {
          return (
            content +
            '<p style="padding: 0px 2px 2px 2px;">' +
            '<i class="fa fa-fw fa-car"></i>&emsp;' +
            car.PickUpLocation +
            '&nbsp;(' +
            $filter('date')(car.PickUpDateTime, 'MM/dd/yyyy  h:mma') +
            ')' +
            '&nbsp;<b>&#8594;</b>&nbsp;' +
            car.DropOffLocation +
            ' (' +
            $filter('date')(car.DropOffDateTime, 'MM/dd/yyyy  h:mma') +
            ')</p>'
          )
        }, markerContent)
        return markerContent
      }

      function createHotelMarker(hotelList, markerContent) {
        markerContent = hotelList.reduce(function (content, hotel) {
          return (
            content +
            '<p style="padding: 0px 2px 2px 2px;">' +
            '<i class="fa fa-fw fa-bed"></i>&emsp;' +
            hotel.HotelName +
            ',&nbsp;' +
            hotel.Address +
            '&nbsp;(' +
            $filter('date')(hotel.CheckInDate, 'MM/dd/yyyy  h:mma') +
            '&nbsp;<b>&#8594;</b>&nbsp;' +
            $filter('date')(hotel.CheckOutDate, 'MM/dd/yyyy  h:mma') +
            ')</p>'
          )
        }, markerContent)
        return markerContent
      }

      function createLimoMarker(limoList, markerContent) {
        markerContent = limoList.reduce(function (content, limo) {
          return (
            content +
            '<p style="padding: 0px 2px 2px 2px;">' +
            '<i class="fa fa-fw fa-taxi"></i>&emsp;' +
            limo.PickUp +
            '&nbsp;(' +
            $filter('date')(limo.DepartureDate, 'MM/dd/yyyy  h:mma') +
            ')' +
            '&nbsp;<b>&#8594;</b>&nbsp;' +
            limo.DropOff +
            '</p>'
          )
        }, markerContent)
        return markerContent
      }

      function createFlightMarker(flightList, markerContent) {
        markerContent = flightList.reduce(function (content, flight) {
          return (
            content +
            '<p style="padding: 0px 2px 2px 2px;">' +
            '<i class="fa fa-fw fa-plane"></i>&emsp;' +
            flight.DepartureAirport +
            '&nbsp;(' +
            $filter('date')(flight.DepartureDateTime, 'MM/dd/yyyy  h:mma') +
            ')&nbsp;<b>&#8594;</b>&nbsp;' +
            flight.ArrivalAirport +
            '&nbsp;(' +
            $filter('date')(flight.ArrivalDateTime, 'MM/dd/yyyy  h:mma') +
            ')</p>'
          )
        }, markerContent)
        return markerContent
      }
      //To show marker information on click of marker
      function showInfoMarkerWindow(
        userRole,
        marker,
        bookingType,
        id,
        markerIndexNum = 0,
        DeviceToken = '',
        OSPlatform,
      ) {
        const traveler = $scope.selectedRow.Member
          ? $scope.selectedRow.Member
          : $scope.selectedRow.Traveler
        let strPreviousClassName = ''
        let strNextClassName = ''
        if (markerIndexNum < 1) {
          strPreviousClassName = 'prevLocator disabled'
        } else {
          strPreviousClassName = 'prevLocator'
        }
        if (markerIndexNum == markerLocators[marker.city].length - 1) {
          strNextClassName = 'nextLocator disabled'
        } else {
          strNextClassName = 'nextLocator'
        }

        let btnHtml =
          '<button angular-ripple class="btn" style="margin-bottom:0px;" title="SMS traveler" ng-click="sendSms(' +
          id +
          ", '" +
          DeviceToken +
          "', '" +
          OSPlatform +
          "', '" +
          bookingType +
          '\')" type="button"><i class="fa fa-comment"></i></button>'

        if (
          !traveler.Phone ||
          userRole === obexRoles.roleTravelManager ||
          userRole === obexRoles.roleObexAdmin
        ) {
          btnHtml =
            '<button angular-ripple class="btn" style="margin-bottom:0px;opacity: 0.6;cursor: not-allowed" title="Traveler phone is required" type="button"><i class="fa fa-comment"></i></button>'
        }

        return (
          '<div style="float:left;width:100%">' +
          '<div style="float:left;width:100%"><font size="4">' +
          marker.DisplayTitle +
          '&nbsp' +
          '</font>' +
          marker.content +
          '</div>' +
          '<div style="float:left;width:40%"><a href ng-click="getTripDetails($event, ' +
          userRole +
          ')" ><span style="border-bottom: 1px solid" bookingType=' +
          bookingType +
          ' bookingId=' +
          id +
          '>Details</span></a>' +
          '</div>' +
          '<div style="float:right;text-align:center;width:10%">' +
          btnHtml +
          '</div>' +
          '<div class="locatorsPaging" data-idx=' +
          markerIndexNum +
          ' data-cityname="' +
          marker.city +
          '">' +
          '<a id="prevTab" class="' +
          strPreviousClassName +
          '" href="javascript:void(0);" title="Previous"></a>' +
          '&nbsp;' +
          '<a id="nextTab" class="' +
          strNextClassName +
          '" href="javascript:void(0);" title="Next"></a>' +
          '</div>' +
          '</div>'
        )
      }

      //Creating alert markers
      function createAlertMarker(alert, alertValue, maps, infoWindow) {
        let marker = new google.maps.Marker({
          map: maps,
          position: new google.maps.LatLng(alert.Latitude, alert.Longitude),
          icon: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
          title: alert.Category,
          alertValue: alertValue,
        })
        let content =
          '<p> ' +
          alert.Category +
          ' </p><p>' +
          alert.PublishDate +
          '</p><p><b>' +
          alert.Title +
          '</b></p><p>' +
          alert.Summary +
          '</p><p><a href= ' +
          alert.LinkUrl +
          ' target="_blank" >More Details</a></p>'
        content =
          content +
          '<p><a href="#" class="exportat" item-category="' +
          alert.Category +
          '">Export Travelers Affected</a></p>'
        marker.content = content
        google.maps.event.addListener(marker, 'click', function () {
          infoWindow.setContent(marker.content)
          infoWindow.open(maps, marker)
        })
        return marker
      }

      //To open information window
      $scope.openInfoWindow = function (e, selectedMarker) {
        e.preventDefault()
        google.maps.event.trigger(selectedMarker, 'click')
      }
      $scope.travelersGrid = {
        paginationPageSizes: [5, 10, 25, 50],
        enableFiltering: true,
        enableGridMenu: false,
        paginationPageSize: 10,
        useExternalPagination: true,
        useExternalSorting: false,
        enableRowSelection: true,
        enableSelectAll: false,
        enableRowHeaderSelection: false,
        multiSelect: false,
        showTreeExpandNoChildren: false,
        rowHeight: 20,
        columnDefs: [
          {
            name: 'DisplayTitle',
            height: '200px',
            displayName: 'Travelers',
            cellTemplate:
              '<span style="padding:3px"> {{ row.entity.DisplayTitle }} </span>',
            enableHiding: false,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableSorting: true,
            enableFiltering: true,
            enableRowSelection: true,
          },
        ],
        //Information Pop up on selection of travelers grid row
        onRegisterApi: function (gridApiTravelers) {
          $scope.gridApiTravelers = gridApiTravelers
          gridApiTravelers.selection.on.rowSelectionChanged($scope, function (
            row,
          ) {
            if ($scope.isTravelers) {
              google.maps.event.trigger(row.entity, 'click')
              $scope.isDetails = false
            }
          })
        },
      }

      $scope.travelersStateChanged = function () {
        for (let travelerMarker of $scope.travelersMarkers) {
          travelerMarker.setVisible($scope.isTravelers)
        }
      }

      $scope.alertValues = [
        { level: 1, isShowAlert: false, title: 1 },
        { level: 2, isShowAlert: false, title: 2 },
        { level: 4, isShowAlert: false, title: 3 },
        { level: 8, isShowAlert: true, title: 4 },
      ]
      $scope.alertsStateChanged = function (isShowAlert, alertValue) {
        $scope.alertsGrid.data = []
        for (let alertMarker of $scope.AlertMarkers) {
          if (alertMarker.alertValue === alertValue) {
            alertMarker.setVisible(isShowAlert)
          }
          if (alertMarker.visible === true) {
            $scope.alertsGrid.data.push(alertMarker)
          }
        }
      }

      function reloadMarkers() {
        if (!!$scope.travelersMarkers) {
          $scope.travelersMarkers.map((travelersMarkers) => {
            travelersMarkers.setMap(null)
            travelersMarkers.setVisible($scope.isTravelers)
            return travelersMarkers
          })
        }
      }
      //Search according to radio button
      $scope.pre31daysSelected = function () {
        $scope.next24hours = false
        $scope.days1to7 = false
        $scope.post31days = false
        $scope.customDate = false
        let fromDate = new Date()
        let toDate = new Date()
        $scope.isCustomDate = false
        reloadMarkers()
        fromDate.setDate(fromDate.getDate() - 31)
        fromDate = $filter('date')(fromDate, 'yyyy-MM-dd')
        toDate = $filter('date')(toDate, 'yyyy-MM-dd')
        $scope.isDetails = false
        searchTravelersData(fromDate, toDate, maps, infoWindow)
      }
      $scope.next24hoursSelected = function () {
        $scope.pre31days = false
        $scope.days1to7 = false
        $scope.post31days = false
        $scope.customDate = false
        let fromDate = new Date()
        let toDate = new Date()
        $scope.isCustomDate = false
        reloadMarkers()
        toDate.setHours(toDate.getHours() + 24)
        fromDate = $filter('date')(fromDate, 'yyyy-MM-dd')
        toDate = $filter('date')(toDate, 'yyyy-MM-dd')
        $scope.isDetails = false
        searchTravelersData(fromDate, toDate, maps, infoWindow)
      }
      $scope.days1to7Selected = function () {
        $scope.pre31days = false
        $scope.next24hours = false
        $scope.post31days = false
        $scope.customDate = false
        let fromDate = new Date()
        let toDate = new Date()
        $scope.isCustomDate = false
        reloadMarkers()
        toDate.setDate(toDate.getDate() + 7)
        fromDate = $filter('date')(fromDate, 'yyyy-MM-dd')
        toDate = $filter('date')(toDate, 'yyyy-MM-dd')
        $scope.isDetails = false
        searchTravelersData(fromDate, toDate, maps, infoWindow)
      }
      $scope.post31daysSelected = function () {
        $scope.pre31days = false
        $scope.next24hours = false
        $scope.days1to7 = false
        $scope.customDate = false
        let fromDate = new Date()
        let toDate = new Date()
        $scope.isCustomDate = false
        reloadMarkers()
        toDate.setDate(toDate.getDate() + 31)
        fromDate = $filter('date')(fromDate, 'yyyy-MM-dd')
        toDate = $filter('date')(toDate, 'yyyy-MM-dd')
        $scope.isDetails = false
        searchTravelersData(fromDate, toDate, maps, infoWindow)
      }
      $scope.customDateSelected = function () {
        $scope.pre31days = false
        $scope.next24hours = false
        $scope.days1to7 = false
        $scope.post31days = false
        $scope.isCustomDate = true
      }
      $scope.searchCustomDate = function () {
        let fromDate = new Date()
        let toDate = new Date()
        reloadMarkers()
        fromDate = $filter('date')($scope.customFromDate, 'yyyy-MM-dd')
        toDate = $filter('date')($scope.customToDate, 'yyyy-MM-dd')
        $scope.isDetails = false
        searchTravelersData(fromDate, toDate, maps, infoWindow)
      }
      //To get search data for next24hours default selection on page load
      if ($scope.next24hours) {
        $scope.next24hoursSelected()
      }
      $scope.searchTravelersNearAlertsOrInCity = function () {
        let fromDate = new Date()
        let toDate = new Date()
        reloadMarkers()
        if (document.getElementById('pre31days').checked) {
          fromDate.setDate(fromDate.getDate() - 31)
          fromDate = $filter('date')(fromDate, 'yyyy-MM-dd')
          toDate = $filter('date')(toDate, 'yyyy-MM-dd')
          searchTravelersData(fromDate, toDate, maps, infoWindow)
        } else if (document.getElementById('next24hours').checked) {
          toDate.setHours(toDate.getHours() + 24)
          fromDate = $filter('date')(fromDate, 'yyyy-MM-dd')
          toDate = $filter('date')(toDate, 'yyyy-MM-dd')
          searchTravelersData(fromDate, toDate, maps, infoWindow)
        } else if (document.getElementById('post31days').checked) {
          toDate.setDate(toDate.getDate() + 31)
          fromDate = $filter('date')(fromDate, 'yyyy-MM-dd')
          toDate = $filter('date')(toDate, 'yyyy-MM-dd')
          searchTravelersData(fromDate, toDate, maps, infoWindow)
        } else if (document.getElementById('customDate').checked) {
          fromDate = $filter('date')($scope.customFromDate, 'yyyy-MM-dd')
          toDate = $filter('date')($scope.customToDate, 'yyyy-MM-dd')
          searchTravelersData(fromDate, toDate, maps, infoWindow)
        } else if (document.getElementById('days1to7').checked) {
          toDate.setDate(toDate.getDate() + 7)
          fromDate = $filter('date')(fromDate, 'yyyy-MM-dd')
          toDate = $filter('date')(toDate, 'yyyy-MM-dd')
          searchTravelersData(fromDate, toDate, maps, infoWindow)
        }
      }

      function exportToExcel(fromDate, toDate, selectedClientId) {
        progress.start()
        travelerTrack
          .getTravelerExportList(
            fromDate,
            toDate,
            $scope.isTravelersNearToAlerts,
            selectedClientId,
          )
          .then(
            function (travelers) {
              $scope.getArray = []
              if (!!travelers.data) {
                $scope.getArray = travelers.data.map(function (traveler) {
                  return {
                    travelerName: traveler.TravelerName
                      ? traveler.TravelerName
                      : '',
                    travelArrangerName:
                      traveler.TravelArrangers &&
                      !!traveler.TravelArrangers.length
                        ? traveler.TravelArrangers[0].FirstName +
                          ' ' +
                          traveler.TravelArrangers[0].LastName
                        : '',
                    email:
                      traveler.Email &&
                      traveler.TravelArrangers &&
                      !!traveler.TravelArrangers.length
                        ? traveler.Email +
                          ', ' +
                          traveler.TravelArrangers[0].Email
                        : traveler.Email
                        ? traveler.Email
                        : '',
                    title: traveler.Title ? traveler.Title : '',
                    segment: traveler.Segment ? traveler.Segment : '',
                    startDate: traveler.StartDate ? traveler.StartDate : '',
                    endDate: traveler.EndDate ? traveler.EndDate : '',
                    departureCity: traveler.DepartureCity
                      ? traveler.DepartureCity
                      : '',
                    arrivalCity: traveler.ArrivalCity
                      ? traveler.ArrivalCity
                      : '',
                    currentLocation: traveler.CurrentLocation
                      ? traveler.CurrentLocation
                      : '',
                    currentLocationCountry: traveler.CurrentLocationCountry
                      ? traveler.CurrentLocationCountry
                      : '',
                  }
                })
              }
            },
            function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: [
                    '$scope',
                    function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`
                      $scope.errTitle = 'Traveler Track Export CSV Error' //PLACE HOLDER
                    },
                  ],
                })
              }
            },
          )
          .finally(function () {
            progress.complete()
          })
      }
      //Displaying in tree structure
      let writeoutNode = function (childArray, currentLevel, dataArray) {
        childArray.forEach(function (childNode) {
          if (!!childNode.childElement.length || childNode.singleparent) {
            childNode.$$treeLevel = currentLevel
          }
          dataArray.push(childNode)
          writeoutNode(childNode.childElement, currentLevel + 1, dataArray)
        })
      }
      //  Creation parent with child nodes
      function setTravelersGridData(travelersMarkers) {
        let parentWithChild = []
        let parentListTraveler = []
        if (!!travelersMarkers.length) {
          let newparent = travelersMarkers[0]
          newparent.DisplayName = ''
          parentListTraveler[0] = newparent
          travelersMarkers.forEach(function (travelersmarker) {
            newparent = travelersmarker
            let flag = false
            parentListTraveler
              .filter(function (parentList) {
                return travelersmarker.travelerName == parentList.travelerName
              })
              .map(function (parentList) {
                flag = true
              })
            if (flag === false) {
              newparent.DisplayName = ''
              parentListTraveler.push(newparent)
            }
          })
          if (!!parentListTraveler) {
            parentListTraveler.forEach(function (parentList) {
              parentListTravelersListByTripId[parentList.TripId] =
                parentList.TripId
              let parent = parentList
              parent.DisplayTitle =
                parent.travelerName + ' ' + parent.DisplayName
              parent.childElement = []
              let parentListMarkers = travelersMarkers.filter(function (
                travelersmarker,
              ) {
                return (
                  parentList.travelerName == travelersmarker.travelerName &&
                  parentList != travelersmarker
                )
              })
              parentListMarkers.forEach(function (travelersmarker) {
                let child = travelersmarker
                child.childElement = []
                child.DisplayTitle = travelersmarker.displayTitle
                parent.childElement.push(child)
              })
              parentWithChild.push(parent)
            })
          }
          $scope.travelersGrid.data = []
          parentWithChild.map(function (parentwithchild) {
            parentwithchild.singleparent = false
          })
          parentWithChild
            .filter(function (parentchild) {
              return !parentchild.childElement.length
            })
            .map(function (parentchild) {
              parentchild.singleparent = true
            })
          writeoutNode(parentWithChild, 0, $scope.travelersGrid.data)
        } else {
          $scope.travelersGrid.data = []
        }
      }
      // get trip details by trip Id
      $scope.getTripDetails = function (e, userRole) {
        let bookingType, bookingId
        bookingType = e.target.attributes.bookingType.value
        bookingId = e.target.attributes.bookingId.value
        progress.start()
        // generate trip container booking details
        $scope.isDetails = false
        switch (bookingType) {
          // generate trip container booking details
          case 'Trip':
            $scope.bookingListInDetails = []
            $scope.isDetails = true
            generateTripDetails(bookingId)
            break
          case 'Flight':
            let flightContext = []
            $scope.bookingListInDetails = []
            $scope.isDetails = true
            tripsDashBoard
              .getFlightsDashById(bookingId)
              .then(
                function (flights) {
                  flightContext.push(flights.data)
                  $scope.bookingListInDetails = generateBookingFlight(
                    flightContext,
                  )
                  $scope.selectedRow = $scope.bookingListInDetails[0]
                  $scope.TravelerEmail = flights.data.Member.Email
                  $scope.TravelerCompanyId = flights.data.Member.Organization.Id
                },
                function (err) {
                  if (err.status != 401) {
                    ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: [
                        '$scope',
                        function ($scope) {
                          $scope.errMsg = `<p>${err.statusText}</p>`
                          $scope.errTitle = 'Traveler Track Details Error' //PLACE HOLDER
                        },
                      ],
                    })
                  }
                },
              )
              .finally(function () {
                progress.complete()
              })
            break
          case 'Car':
            let carContext = []
            $scope.bookingListInDetails = []
            $scope.isDetails = true
            tripsDashBoard
              .getCarsDashById(bookingId)
              .then(
                function (cars) {
                  carContext.push(cars.data)
                  $scope.bookingListInDetails = generateBookingCar(carContext)
                  $scope.selectedRow = $scope.bookingListInDetails[0]
                  $scope.TravelerEmail = cars.data.Member.Email
                  $scope.TravelerCompanyId = cars.data.Member.Organization.Id
                },
                function (err) {
                  if (err.status != 401) {
                    ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: [
                        '$scope',
                        function ($scope) {
                          $scope.errMsg = `<p>${err.statusText}</p>`
                          $scope.errTitle = 'Traveler Track Details Error' //PLACE HOLDER
                        },
                      ],
                    })
                  }
                },
              )
              .finally(function () {
                progress.complete()
              })
            break
          case 'Hotel':
            let hotelContext = []
            $scope.bookingListInDetails = []
            $scope.isDetails = true
            tripsDashBoard
              .getHotelsDashById(bookingId)
              .then(
                function (hotels) {
                  hotelContext.push(hotels.data)
                  $scope.bookingListInDetails = generateBookingHotel(
                    hotelContext,
                  )
                  $scope.selectedRow = $scope.bookingListInDetails[0]
                  $scope.TravelerEmail = hotels.data.Member.Email
                  $scope.TravelerCompanyId = hotels.data.Member.Organization.Id
                },
                function (err) {
                  if (err.status != 401) {
                    ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: [
                        '$scope',
                        function ($scope) {
                          $scope.errMsg = `<p>${err.statusText}</p>`
                          $scope.errTitle = 'Traveler Track Details Error' //PLACE HOLDER
                        },
                      ],
                    })
                  }
                },
              )
              .finally(function () {
                progress.complete()
              })
            break
          case 'Limo':
            let limoContext = []
            $scope.bookingListInDetails = []
            $scope.isDetails = true
            tripsDashBoard
              .getLimosDashById(bookingId)
              .then(
                function (limos) {
                  limoContext.push(limos.data)
                  $scope.bookingListInDetails = generateBookingLimo(limoContext)
                  $scope.selectedRow = $scope.bookingListInDetails[0]
                  $scope.TravelerEmail = limos.data.Member.Email
                  $scope.TravelerCompanyId = limos.data.Member.Organization.Id
                },
                function (err) {
                  if (err.status != 401) {
                    ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: [
                        '$scope',
                        function ($scope) {
                          $scope.errMsg = `<p>${err.statusText}</p>`
                          $scope.errTitle = 'Traveler Track Details Error' //PLACE HOLDER
                        },
                      ],
                    })
                  }
                },
              )
              .finally(function () {
                progress.complete()
              })
            break
        }
        $scope.userRole = userRole
      }
      //generate trip details by trip Id
      function generateTripDetails(id) {
        tripsDashBoard
          .getTripsDashbyId(id)
          .then(
            function (trips) {
              let tripFlightContext = trips.data.Flights
              let tripCarContext = trips.data.Cars
              let tripHotelContext = trips.data.Hotels
              const tripLimoContext = trips.data.Limos
              let flightList = []
              let carList = []
              let hotelList = []
              let limoList = []
              if (!!tripFlightContext.length) {
                flightList = generateBookingFlight(
                  tripFlightContext,
                  trips.data.Member,
                )
              }
              if (!!tripCarContext.length) {
                carList = generateBookingCar(tripCarContext, trips.data.Member)
              }
              if (!!tripHotelContext.length) {
                hotelList = generateBookingHotel(
                  tripHotelContext,
                  trips.data.Member,
                )
              }
              if (!!tripLimoContext.length) {
                limoList = generateBookingLimo(
                  tripLimoContext,
                  trips.data.Member,
                )
              }

              /*$scope.bookingListInDetails = [flightList, carList, hotelList].reduce(function(prevData,
            currData) {
            return prevData.concat(currData);
          }, []);*/
              $scope.bookingListInDetails = [].concat(
                flightList,
                carList,
                hotelList,
                limoList,
              )

              let sortByDateAsc = function (a, b) {
                let firstStartDate = moment(a.StartDate).format('MM-DD-YYYY')
                let secondStartDate = moment(b.StartDate).format('MM-DD-YYYY')
                if (firstStartDate > secondStartDate) {
                  return 1
                } else if (firstStartDate < secondStartDate) {
                  return -1
                } else if (firstStartDate === secondStartDate) {
                  if (a.BookingTypeName === 'A' && b.BookingTypeName === 'A') {
                    const tempStartDate = moment(a.StartDate).format(
                      'MM-DD-YYYY HH:mm',
                    )
                    const tempEndDate = moment(b.StartDate).format(
                      'MM-DD-YYYY HH:mm',
                    )
                    if (tempStartDate > tempEndDate) {
                      return 1
                    } else {
                      return -1
                    }
                  } else if (a.BookingTypeName === 'A') {
                    return -1
                  } else if (b.BookingTypeName === 'A') {
                    return 1
                  } else if (
                    a.BookingTypeName === 'H' &&
                    b.BookingTypeName === 'C'
                  ) {
                    return -1
                  } else if (
                    a.BookingTypeName === 'C' &&
                    b.BookingTypeName === 'H'
                  ) {
                    return 1
                  } else {
                    return 0
                  }
                }
              }
              $scope.bookingListInDetails.sort(sortByDateAsc)
              $scope.selectedRow = $scope.bookingListInDetails[0]
              $scope.TravelerEmail = trips.data.Member.Email
              $scope.TravelerCompanyId = trips.data.Member.Organization.Id
            },
            function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: [
                    '$scope',
                    function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`
                      $scope.errTitle = 'Traveler Track Details Error' //PLACE HOLDER
                    },
                  ],
                })
              }
            },
          )
          .finally(function () {
            progress.complete()
          })
      }
      $scope.CloseTripDetails = function () {
        $scope.isDetails = false
      }

      function generateBookingFlight(flightContext, member) {
        return flightContext.map(function (flight) {
          const travelerName = flight.Member
            ? flight.Member.LastName + ', ' + flight.Member.FirstName
            : member
            ? member.LastName + ', ' + member.FirstName
            : ''
          return {
            Id: flight.Id,
            BookingTypeName: 'A',
            StartDate: flight.DepartureDateTime,
            Company: flight.Member
              ? flight.Member.Organization.Name
              : member
              ? member.Organization.Name
              : '',
            Seg: 1,
            TravelerDisplayName: travelerName,
            Travelers: [travelerName],
            Supplier: flight.OperatingAirline,
            Source: !!flight.BookingSource ? flight.BookingSource : '',
            Pnr: !!flight.Pnr ? flight.Pnr : '',
            StartLocation: flight.DepartureName,
            EndLocation: flight.ArrivalName,
            BookingType: 'Flight',
            FlightNumber: flight.FlightNumber,
            Duration: flight.Duration,
            Seat: flight.Seats,
            EndDate: flight.ArrivalDateTime,
            Class:
              (!!flight.BookingClass ? flight.BookingClass : '') +
              (!!flight.BookingClassDescription
                ? ' - ' + flight.BookingClassDescription
                : ''),
            Status: !!flight.ConfirmationNumber
              ? 'Confirmed - ' + flight.ConfirmationNumber
              : '',
            Type: 0,
            NumberOfRooms: 0,
            Address: 0,
            Total:
              currency.getCurrencySymbol(flight.AirReservation.CurrencyCode) +
              flight.AirReservation.TotalFare,
            DeviceToken: flight.Member
              ? flight.Member.DeviceToken
              : member
              ? member.DeviceToken
              : null,
            OSPlatform: flight.Member
              ? flight.Member.OSPlatform
              : member
              ? member.OSPlatform
              : null,
            Traveler: flight.Member ? flight.Member : member,
          }
        })
      }

      function generateBookingCar(carContext, member) {
        return carContext.map(function (car) {
          const travelerName = car.Member
            ? car.Member.LastName + '/' + car.Member.FirstName
            : member
            ? member.LastName + ', ' + member.FirstName
            : ''
          return {
            Id: car.Id,
            BookingTypeName: 'C',
            StartDate: car.PickUpDateTime,
            Company: car.Member
              ? car.Member.Organization.Name
              : member
              ? member.Organization.Name
              : '',
            Seg: 2,
            TravelerDisplayName: travelerName,
            Travelers: [travelerName],
            Supplier: car.RentalCompany,
            Source: !!car.BookingSource ? car.BookingSource : '',
            Pnr: !!car.Pnr ? car.Pnr : '',
            StartLocation: car.PickUpLocation,
            EndLocation: car.DropOffLocation,
            BookingType: 'Car',
            FlightNumber: 0,
            Duration: 0,
            Seat: 0,
            EndDate: car.DropOffDateTime,
            Class: 0,
            Status: !!car.Confirmation ? 'Confirmed - ' + car.Confirmation : '',
            Type: car.CarModel,
            NumberOfRooms: 0,
            Address: 0,
            Total:
              currency.getCurrencySymbol(car.CurrencyCode) + car.TotalCharge,
            DeviceToken: car.Member
              ? car.Member.DeviceToken
              : member
              ? member.DeviceToken
              : null,
            OSPlatform: car.Member
              ? car.Member.OSPlatform
              : member
              ? member.OSPlatform
              : null,
            Traveler: car.Member ? car.Member : member,
          }
        })
      }

      function generateBookingHotel(hotelContext, member) {
        return hotelContext.map(function (hotel) {
          const travelerName = !!hotel.GuestNames
            ? hotel.GuestNames
            : hotel.Member
            ? hotel.Member.LastName + '/' + hotel.Member.FirstName
            : member
            ? member.LastName + ', ' + member.FirstName
            : ''
          return {
            Id: hotel.Id,
            BookingTypeName: 'H',
            StartDate: hotel.CheckInDate,
            Company: hotel.Member
              ? hotel.Member.Organization.Name
              : member
              ? member.Organization.Name
              : '',
            Seg: 3,
            TravelerDisplayName: travelerName,
            Travelers: [travelerName],
            Supplier: hotel.HotelName,
            Source: !!hotel.BookingSource ? hotel.BookingSource : '',
            Pnr: !!hotel.Pnr ? hotel.Pnr : '',
            StartLocation: '',
            BookingType: 'Hotel',
            FlightNumber: 0,
            Duration: 0,
            Seat: 0,
            EndDate: hotel.CheckOutDate,
            Class: 0,
            Status: !!hotel.Confirmation
              ? 'Confirmed - ' + hotel.Confirmation
              : '',
            Type: hotel.RoomType,
            NumberOfRooms: hotel.NumberOfRooms,
            Address: hotel.Address,
            Total: currency.getCurrencySymbol(hotel.CurrencyCode) + hotel.Total,
            DeviceToken: hotel.Member
              ? hotel.Member.DeviceToken
              : member
              ? member.DeviceToken
              : null,
            OSPlatform: hotel.Member
              ? hotel.Member.OSPlatform
              : member
              ? member.OSPlatform
              : null,
            Traveler: hotel.Member ? hotel.Member : member,
          }
        })
      }

      function generateBookingLimo(limoContext, member) {
        return limoContext.map(function (limo) {
          const travelerName = member.LastName + '/' + member.FirstName
          return {
            Id: limo.Id,
            BookingTypeName: 'L',
            DepartureDate: limo.DepartureDate,
            LimoServiceName: limo.LimoServiceName,
            LocationName: limo.LocationName,
            Seg: 4,
            TravelerDisplayName: travelerName,
            Travelers: [travelerName],
            BookingType: 'Limo',
            Traveler: member,
            BookingSource: limo.BookingSource,
            Cancelled: limo.Cancelled,
            Confirmation: limo.Confirmation,
            DropOff: limo.DropOff,
            IPCC: limo.IPCC,
            ImageLink: limo.ImageLink,
            Instructions: limo.Instructions,
            PickUp: limo.PickUp,
            Pnr: limo.Pnr,
            Time: limo.Time,
            StartDate: limo.DepartureDate,
          }
        })
      }

      // Validate that filtered organization id is defined
      function validateAgencyAndClientSelection() {
        const agency = agencySelectService.getSelectedAgency()
        const client = clientSelectService.getSelectedClient()
        return {
          agencyValid: agency.id != null && Number.isInteger(agency.id),
          clientValid: client.id != null && Number.isInteger(client.id),
        }
      }
      // Watch agencySelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
      $scope.$watch(
        function () {
          return clientSelectService.getSelectedClient()
        },
        function (newValue, oldValue) {
          $scope.travelersGrid.data = []
          const valid = validateAgencyAndClientSelection()
          if (valid.agencyValid && valid.clientValid) {
            if (newValue !== oldValue) {
              selectedClientId = newValue.id
              if (!!selectedClientId) {
                if ($scope.isTravelersNearToAlerts) {
                  $scope.searchTravelersNearAlertsOrInCity()
                } else if ($scope.pre31days) {
                  $scope.pre31daysSelected()
                } else if ($scope.next24hours) {
                  $scope.next24hoursSelected()
                } else if ($scope.days1to7) {
                  $scope.days1to7Selected()
                } else if ($scope.post31days) {
                  $scope.post31daysSelected()
                } else if ($scope.isCustomDate) {
                  $scope.searchCustomDate()
                }
              } else {
                // clear travelers grid and markers
                $scope.isExportData = false
                $scope.travelersGrid.data = []
                reloadMarkers()
              }
            }
          }
        },
        true,
      )
    },
  ])
})(angular.module('obex'))



// WEBPACK FOOTER //
// ./client/js/controllers/travelerTrackController.js